'use client';

import type { OrderSearchParamsQuery } from '@wolfejs/ms-api-js/src/types/pgcorp';
import { usePGCorpOrders } from '@wolfejs/ms-api-react';
import { ApiError } from '@wolfejs/ms-api-react/src/components/ApiError';
import { OrderHistory } from '@wolfejs/ms-ui/OrderHistory/OrderHistory';
import { Spinner } from '@wolfejs/ui/Spinner';
import { useEffect, useState } from 'react';

const PAGE_NUMBER = 1;
const PAGE_SIZE = 10;

const defaultPagination = {
  pageNumber: PAGE_NUMBER,
  pageSize: PAGE_SIZE,
  search: undefined,
  status: 'all',
};

export function OrderHistoryPageContainer() {
  const [searchParams, setSearchParams] = useState<OrderSearchParamsQuery>({ ...defaultPagination });
  const { data: response, isLoading, refetch, error } = usePGCorpOrders(searchParams, { enabled: !!searchParams });

  useEffect(() => {
    refetch();
  }, [searchParams]);

  if (isLoading)
    return (
      <div className="flex h-[65vh] items-center justify-center">
        <Spinner color="var(--primary)" size={50} />
      </div>
    );
  if (error) return <ApiError error={error} />;

  return (
    <OrderHistory
      orders={response?.data}
      lastPage={response?.pagination?.lastPage ?? 1}
      isLoading={isLoading}
      searchParams={searchParams}
      onSearchParamsChange={setSearchParams}
    />
  );
}
